import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

type MessageKey = 'loadingIndicatorAriaLabel';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  loadingIndicatorAriaLabel: {
    defaultMessage: 'Loading',
    description: 'Aria label of the loading indicator',
    id: 'boxForm.loadingForm.loadingIndicatorAriaLabel',
  },
});

export default messages;
